export default function(script, style) {
  return `
  <template>
    <fx-form-parser :business-code="businessCode" :item-code="itemCode" :action="action" :item-url="itemUrl" :extend-params='extension' @save="save"/>
  </template>
  <script>
  // 在项目的main.js中引用以下代码
  // import EleForm from 'vue-ele-form'
  // import FRender from 'fx-form-designer'
  // import FxFormParser from 'fx-form-parser'
  // import ElementUI from 'element-ui'
  // import 'element-ui/lib/theme-chalk/index.css'
  // Vue.use(ElementUI)
  // Vue.use(EleForm)
  // Vue.use(FxFormParser);

  import fxFormParser from 'fx-form-parser';
  export default {
    components: { fxFormParser },
    data() {
      return {
        businessCode: '', //业务请求代码，每次创建是生成一个uuid
        itemCode: '', //事项代码
        action: 'create', //表单动作，只能取create(新建),modify(修改),view(查看)三者之一
        itemUrl: '', //获取事项数据的接口基地址
        extension: '' //JSON格式的字符串，key加双引号
      };
    },
    methods: {
      ${script}
      save(data) {
        console.log(data);
        return Promise.resolve();
      }
    }
  };
  </script>
  <style lang="css">
    ${style}
  </style>  
  `;
}
